import { render } from "./newSurvey.vue?vue&type=template&id=5618e63a&scoped=true"
import script from "./newSurvey.vue?vue&type=script&lang=js"
export * from "./newSurvey.vue?vue&type=script&lang=js"

import "./newSurvey.vue?vue&type=style&index=0&id=5618e63a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5618e63a"]])

export default __exports__